export const getUrlCompanyId = (pathname: string) => {
  const urlCompanyIdMatch = pathname.match(/^\/app\/([^/]+)/i);

  return urlCompanyIdMatch ? urlCompanyIdMatch[1] : null;
};
